import { UPDATE_OUTAGE_DATA, UPDATE_OUTAGE_STATUS, UPDATE_BACKDOOR_CODE_USAGE } from './store';
import outageApi from './services/outage-api';
import store from '../../store';
import appConfig from '../../app.config';
import { OutageEvents } from './outage-events';
import outageHelper from './outage-helper';

export default {
  name: 'outageManager',
  async init() {
    await this.loadOutageInfo();
    this.setupSessionForBackdoorUseIfCodeAvailable();
  },
  startMonitoring() { // this is to be called once when app loads
    this.startClock();
    this.handleCurrentSessionIfOutage(false);
    this.notifyOutageWarningSubscribers();
  },
  notifyLoginUserChange() { // this is to be called when login user changed
    try {
      this.handleCurrentSessionIfOutage(true);
    } catch (error) {
      console.error(error);
    }
  },

  // ------------------------------------------------//
  // ----------private methods ----------------------//
  // ------------------------------------------------//

  async loadOutageInfo() {
    try {
      const outagedata = await outageApi.getOutageInfo();
      if (outagedata && outagedata.length > 0) {
        store.dispatch(UPDATE_OUTAGE_DATA, outagedata[0]);
      }
    } catch (error) {
      console.error(error);
    }
  },

  setupSessionForBackdoorUseIfCodeAvailable() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('outage') && urlParams.get('outage') === appConfig.outageBackdoorCode) {
      store.dispatch(UPDATE_BACKDOOR_CODE_USAGE, new Date());
    }
  },
  setAppOutageStatus(outageStatus) {
    store.dispatch(UPDATE_OUTAGE_STATUS, outageStatus);
    OutageEvents.NotifyOutageSubscribers(outageStatus);
  },

  startClock() {
    const clockFrequency = 1; // every 1 minute
    setInterval(() => {
      try {
        this.checkForOutageUpdates();
        this.notifyOutageWarningSubscribers();
        this.handleCurrentSessionIfOutage(true);
      } catch (error) { console.error(error); }
    }, clockFrequency * 1000 * 60); // <--count in minutes ---//
  },
  checkForOutageUpdates() {
    if (outageHelper.isOutageRequestTime() || !outageHelper.isOutageConfirmed()) {
      this.loadOutageInfo();
    }
  },
  notifyOutageWarningSubscribers() {
    const warnInfo = outageHelper.getOutageWarningInfo();
    OutageEvents.NotifyWarningSubscribers(warnInfo);
  },

  handleCurrentSessionIfOutage(checkForUser = true) {
    if (outageHelper.isInOutage()) {
      const ignoreUserCheck = (!checkForUser && !store.getters.loggedUser);
      if (ignoreUserCheck || outageHelper.isUserAllowedForBackdoor()) {
        if (outageHelper.isBackdoorCodeUsageValidForTheCurrentSession()) {
          this.setAppOutageStatus(false);
          return false;
        }
      }
      this.setAppOutageStatus(true);
      return true;
    }
    this.setAppOutageStatus(false);
    return false;
  },
};
